import type { FC } from 'react';
import type { TeamType } from 'types/types';
import Image from 'next/image';
import { Body, Heading } from 'components/text';

import styles from './TheTeam.module.scss';

type TheTeamProps = {
  teamMembers: TeamType[];
};

const TheTeam: FC<TheTeamProps> = ({ teamMembers }) => {
  if (teamMembers.length === 0) {
    return null;
  }

  return (
    <section className={styles.theTeamPage}>
      {teamMembers.map((member, index) => (
        <article className={styles.teamMemberCard} key={member.id}>
          <div className={styles.teamMemberCardImage}>
            <Image src={member.image} alt={member.name} layout='fill' objectFit='cover' objectPosition='top center' priority={index <= 4} />
          </div>
          <div className={styles.teamMemberCardDetails}>
            <Heading
              fontSize={20}
              className={styles.teamMemberCardDetailsMemberName}
              title={member.name}
            >
              {member.name}
            </Heading>
            <Body
              fontSize={16}
              color="gold-dark"
              className={styles.teamMemberCardDetailsMemberRole}
              title={member.jobTitle}
            >
              {member.jobTitle}
            </Body>
          </div>
        </article>
      ))}
    </section>
  );
};

export default TheTeam;
